import { useQuery } from '@apollo/client/react';
import { gql } from '@apollo/client';

const INVITATION_QUERY = gql`
  query Invitation($token: String!) {
    invitation(token: $token) {
      id
      email
      status
      expiresAt
      projectName
      inviterName
      project {
        id
        name
        address
        creator {
          fullName
        }
      }
      userExists
    }
  }
`;

export function useInvitation(token: string) {
  const { data, loading, error } = useQuery(INVITATION_QUERY, {
    variables: { token },
    skip: !token,
  });

  const invitation = (data as any)?.invitation;

  return { invitation, loading, error };
}